import { twMerge } from "tailwind-merge";
import {
  Button,
  Card,
  CardContent,
  CardHeader,
  H5,
  H6,
} from "@sellar-io/components";
import { ReactElement } from "react";
import { Icon } from "../../../../components";
import { Alert } from "../../../../components/alert/Alert";
import { IntegrationAppDelete } from "../IntegrationAppDelete";
import { useIntegrationList } from "../../../../hooks/api/v2/integration/useIntegrationList";
import { useSellarIntegration } from "../../../../hooks/api/v2/integration/useSellarIntegration";

export const SharedIntegrationConfirmContent = ({
  integrationType,
  oAuth2Url,
}: {
  integrationType: "xero" | "quickbooks" | "freeagent";
  oAuth2Url: string;
}): ReactElement => {
  const sellarIntegrationQuery = useSellarIntegration();
  const integrationQuery = useIntegrationList({});
  const integration = integrationQuery.data?.pages[0]?.find(
    (integration) => integration.type === integrationType,
  );
  const sellarIntegrationApiKey = sellarIntegrationQuery.data?.apiKey;

  return (
    <>
      {!!sellarIntegrationApiKey && (
        <Alert
          type={"warning"}
          className={"mx-2 w-full"}
          message={`You currently have your Sellar API key active. If this is in use with either Breww, BrewMan or ViewPlan please ensure these services are NOT already integrated with ${integrationType}. This could result in duplicate data being entered into your ${integrationType} account.`}
        />
      )}
      <Card className="bg-white">
        <CardHeader className={twMerge("bg-white", "p-4")}>
          <H5>About</H5>
        </CardHeader>
        <CardContent className={"p-4"}>
          <p className={"mb-4"}>
            This integration will automatically push orders that you confirm in
            Sellar to your {integrationType} account and enter them as draft
            invoices.
          </p>
          <p className={"mb-4"}>
            This integration will also match orders received via Sellar to
            customers in your {integrationType} account. If you receive an order
            via Sellar from a new customer, the business name and business email
            fields will be used to add them to your customer list in{" "}
            {integrationType}.
          </p>
        </CardContent>
      </Card>
      <Card className="bg-white">
        <CardHeader
          className={twMerge("bg-white", "flex flex-wrap justify-between p-4")}
        >
          <div className="flex flex-col">
            <H5>Connection</H5>
            <H6>Authorise Sellar to access your {integrationType} account.</H6>
          </div>
          {!integration ? (
            <Button
              size={"small"}
              onClick={() => {
                window.open(oAuth2Url, "_blank");
              }}
            >
              <Icon icon={"LINK"} />
              Connect
            </Button>
          ) : (
            <IntegrationAppDelete
              appName={integrationType}
              integrationId={integration.id}
            />
          )}
        </CardHeader>
        <CardContent className={"p-4"}>
          <p>Current Status: {integration ? "Connected" : "Not connected"}</p>
        </CardContent>
      </Card>
    </>
  );
};
